import React, {
    forwardRef,
    useState,
    useMemo,
    useCallback,
    useEffect,
  } from "react";
  import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
  import { FieldTypes } from "utils/formUtils";
  import message from "components/CustomMessage";
  import GenericMappingForm from "../GenericMappingForm";
  import { split } from "utils/lodashUtils";
  import { Form } from "antd";
  
  const OligoMappingForm = forwardRef(function OligoMappingForm(
    { disableProjectFields, ...props },
    ref
  ) {
    const [form] = Form.useForm();
    const [imageList, setImageList] = useState([]);
    const [loading, setLoading] = useState(true);
  
    const fetchImages = useCallback(
      (params) => {
        const { promise, cancel } =
          ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
            login_id: props.loginConfigId,
            ...params,
          });
        promise
          .then((response) => {
            const { projects } = response;
            //filter projects
            setImageList(projects);
          })
          .catch(() => {
            message.error("Problem fetching images");
          })
          .finally(() => setLoading(false));
  
        return { promise, cancel };
      },
      [props.loginConfigId, props.toolName]
    );
  
    useEffect(() => fetchImages(), [fetchImages]);
  
    const getExtraFieldsData = (config) => {
      const { imageId } = config;
      const data = imageList.reduce(
        (acc, cv) => {
          const { id, name } = cv;
          if (imageId.includes(id)) {
            acc.id.push(id);
            acc.name.push(name);
          }
          return acc;
        },
        { id: [], name: [] }
      );
      return {
        imageId: data.id.join(),
        imageName: data.name.join(),
        //send the property received in config
        ...(config.discovery_config_id && {
          discovery_config_id: config.discovery_config_id,
        }),
      };
    };
  
    const parseExtraFieldsDataFromResponse = useCallback((config) => {
      const { imageId } = config;
      return {
        imageId: split(imageId, ","),
        //send the property received in config
        ...(config.discovery_config_id && {
          discovery_config_id: config.discovery_config_id,
        }),
      };
    }, []);
  
    const extraFields = useMemo(
      () => [
        {
          name: "imageId",
          colSpan: 12,
          type: FieldTypes.MULTI_SELECT,
          loading,
          label: "Image Name",
          options: imageList,
          disabled: disableProjectFields,
          required: true,
          props: {
            autoFocus: !disableProjectFields,
          },
        },
      ],
      [imageList, disableProjectFields, loading]
    );
  
    return (
      <GenericMappingForm
        ref={ref}
        form={form}
        getExtraFieldsData={getExtraFieldsData}
        parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
        extraFields={extraFields}
        {...props}
      />
    );
  });
  
  export default OligoMappingForm;
  